var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHamMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.5,
    height: 15.5,
    viewBox: "0 0 15.5 15.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_56716",
    "data-name": "Group 56716",
    transform: "translate(-287.75 -36.75)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    x2: 13,
    transform: "translate(289 38)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    x2: 13,
    transform: "translate(289 51)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x2: 9.747,
    transform: "translate(289.601 44.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamMenu);
export default __webpack_public_path__ + "static/media/ham-menu.793033837b17a719ff1d11d8b9db5d80.svg";
export { ForwardRef as ReactComponent };